import React from 'react';
import styles from './styles.module.scss';

interface ScoreRingProps {
  score: number;
  size?: number;
}

const ScoreRing: React.FC<ScoreRingProps> = ({ score, size = 40 }) => {
  const radius = (size - 4) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (score / 100) * circumference;
  let color = '#6bde83'; // green
  if (score <= 50) {
    color = '#de6b6b'; // red
  } else if (score < 80) {
    color = '#dbde6b'; // yellow
  }

  return (
    <div className={styles.scoreRing} style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle
          className={styles.background}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="#e0e0e0"
          strokeWidth="4"
        />
        <circle
          className={styles.progress}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth="4"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
        />
      </svg>
      <span className={styles.score}>{score}</span>
    </div>
  );
};

export default ScoreRing; 